import React, { Component } from 'react';

import './style.sass';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

class About extends Component {
    render() {
        return (
            <ScrollAnimation animateIn="fadeInUp" offset={100} animateOnce={true} duration={1}>
                <div className="fondrt-about">
                    <div className="fondrt-about__wrapper">
                        <img
                            className="fondrt-about__image"
                            alt=""
                            loading="lazy"
                            src="/images/pic/fondrt/about.png"
                        />
                        <div className="fondrt-about__content">
                            <div className="fondrt-about__title">О клиенте</div>
                            <div className="fondrt-about__text">
                                Фонд развития территорий — создан на базе Фонда защиты прав
                                дольщиков и Фонда содействия реформированию ЖКХ и объединяет
                                земельные, финансовые и организационные ресурсы для защиты прав и
                                законных интересов дольщиков, модернизации ЖКХ и комплексного
                                развития территорий.
                            </div>
                        </div>
                    </div>
                </div>
            </ScrollAnimation>
        );
    }
}

export default About;
